import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card-content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "content is-small" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Steuerung"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "Linksklick: Türchen bearbeiten"),
    /*#__PURE__*/_createElementVNode("li", null, "Tastatur: Tag eingeben"),
    /*#__PURE__*/_createElementVNode("li", null, "[Enter]: Tag speichern"),
    /*#__PURE__*/_createElementVNode("li", null, "[Esc]: Eingabe Abbrechen"),
    /*#__PURE__*/_createElementVNode("li", null, "[Entf]: Tag entfernen")
  ])
], -1)
const _hoisted_3 = { class: "image is-unselectable" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PreviewDoor = _resolveComponent("PreviewDoor")!
  const _component_ThouCanvas = _resolveComponent("ThouCanvas")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("figure", _hoisted_3, [
      _createElementVNode("img", {
        src: _ctx.store.calendar_background_image
      }, null, 8, _hoisted_4),
      _createVNode(_component_ThouCanvas, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.doors, (door, index) => {
            return (_openBlock(), _createBlock(_component_PreviewDoor, {
              key: `door-${index}`,
              door: door
            }, null, 8, ["door"]))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}